import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';
import { getDateOperators } from '../../utils/getDateOperators';
import { CustomCell } from './components/custom-cell';

export const TABLE_COLUMNS = (thermoboxes, modes) => [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Дата',
		field: 'date',
		width: 100,
		type: 'date',
		filterOperators: getDateOperators(),
		formatter: value => new Date(value).toLocaleDateString('ru-RU'),
		valueGetter: (value, row) => {
			if (!row.date) {
				return '';
			}

			return new Date(row.date);
		},
	},
	{
		headerName: 'Номер отчета',
		field: 'number',
		flex: 2,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Термоконтейнер',
		field: 'thermobox_id',
		flex: 2,
		type: 'singleSelect',
		valueOptions: thermoboxes,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.thermobox) {
				return 0;
			}

			return row.thermobox.id;
		},
	},
	{
		headerName: 'Производитель',
		field: 'partner',
		flex: 2,
		filterOperators: getStringOperators(),
		valueFormatter: (value, row) => {
			if (!row?.thermobox?.partner) {
				return '';
			}

			return row?.thermobox?.partner?.name;
		},
	},
	{
		headerName: 'Т-режим',
		field: 'mode_id',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		sortable: false,
		type: 'singleSelect',
		valueOptions: modes,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.mode) {
				return 0;
			}

			return row.mode.id;
		},
	},
	{
		headerName: 'Кол. повторностей',
		field: 'repeats',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Время сохранения Т-режима',
		field: 'hold_time',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterable: false,
	},
	{
		headerName: 'Внеш. сред. температура',
		field: 'outer_mode',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
		valueFormatter: value => {
			if (!value) {
				return '';
			}

			return `${value} °C`;
		},
	},
	{
		headerName: 'Внут. Д, см',
		field: 'inner_length',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внут. Ш, см',
		field: 'inner_width',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внут. В, см',
		field: 'inner_height',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внут. объем, м³',
		field: 'inner_volume',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Масса на паллете, кг',
		field: 'pallet_weight',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
];

export const NAV_PAGE_LIST = [{ text: 'Сводная таблица валидационных отчетов', href: '/thermoboxes_reports' }];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
